var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDataLoading)?_c('Loader'):_c('div',[_c('Table',{attrs:{"title":_vm.$t('views.devices.title'),"headers":_vm.backupsHeaders,"rows":_vm.backupsRows,"values":_vm.backups},on:{"export":_vm.exportVolumetry}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }